<template>
  <div class="notification-center tw-flex tw-flex-col tw-gap-2">
    <Notify
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
      @accept="onAccept(notification)"
      @reject="onReject(notification)"
      @view="onViewRoomDetail(notification)"
      @close="removeNotification(notification.RefID)"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/event-bus";
import dayjs from "dayjs";

const REQUEST_TO_JOIN_MINUTE = 1;

export default {
  name: "NotificationCenter",
  components: {
    Notify: () => import("@/ui/components/chat/Notify.vue"),
  },
  data() {
    return {
      canPushNotification: false,
      notifications: [
        // {
        //   CreatedAt: "2022-09-21T06:26:02.245770313Z",
        //   CreatorID: "ap-southeast-1:6b6e0132-4b8f-4549-8827-b9a21b942c03",
        //   CreatorName: "Test Room Created4",
        //   RoomID: "ap-southeast-1:6b6e0132-4b8f-4549-8827-b9a21b942c03",
        //   Type: "RoomCreated",
        // },
      ],
    };
  },
  computed: {
    ...mapGetters({
      consoleSocket: "chat/consoleSocket",
      myAgentInfo: "chat/myAgentInfo",
    }),
  },
  mounted() {
    console.log("notification permission", Notification.permission);
    if (!("Notification" in window)) {
      window.alert("This browser does not support desktop notification");
    } else if (Notification.permission === "granted") {
      this.canPushNotification = true;
      this.$store.commit("chat/setCanPushNotification", true);
      console.log("Notification has been accepted.");
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        // If the user accepts, let's create a notification
        if (permission === "granted") {
          console.log("Notification has been accepted.");
          this.canPushNotification = true;
          this.$store.commit("chat/setCanPushNotification", true);
        }
      });
    }

    // Test notification
    // this.pushNotification("Hello, from villa chat system", "new message now");
  },
  watch: {
    consoleSocket: {
      immediate: true,
      handler: function (value) {
        if (value) {
          this.consoleSocket.addEventListener("message", (event) => {
            const data = JSON.parse(event.data);
            if (data.Type === "agent-join-request-notification") {
              console.log("Notification center, new event", data);
              this.pushNotification(
                "Request to join",
                "Someone wants to join your chat room."
              );
              this.notifications.push({ ...data, id: data.RefID });
              setTimeout(() => {
                this.removeNotification(data.RefID);
              }, 1000 * 60 * REQUEST_TO_JOIN_MINUTE);
            }
            if (data.Type === "agent-join-accepted-notification") {
              console.log("Notification center, new event", data);
              this.notifications.push({ ...data, id: data.RefID });
              this.pushNotification(
                "๋Join room",
                "You request has been accepted."
              );
              setTimeout(() => {
                this.removeNotification(data.RefID);
              }, 1000 * 60 * REQUEST_TO_JOIN_MINUTE);
            }
            if (data.Type === "agent-join-rejected-notification") {
              console.log("Notification center, new event", data);
              this.notifications.push({ ...data, id: data.RefID });
              this.pushNotification(
                "๋Join room",
                "You request has been rejected."
              );
              setTimeout(() => {
                this.removeNotification(data.RefID);
              }, 1000 * 60 * REQUEST_TO_JOIN_MINUTE);
            }
            if (data.Type === "RoomCreated") {
              if (
                this.myAgentInfo.Role === "Admin" ||
                this.myAgentInfo.Role === "Service"
              ) {
                EventBus.$emit("new-room-alert", data);
                const createdAt = dayjs(data.CreatedAt).unix();
                this.pushNotification(
                  "New chat room",
                  `Customer name: ${data.CreatorName}`
                );
                this.notifications.push({ ...data, id: createdAt });
                setTimeout(() => {
                  this.removeNotification(createdAt);
                }, 1000 * 60 * 3);
              }
            }
            if (data.Type === "RoomReopened") {
              EventBus.$emit("update-local-room-status", {
                roomID: data.RoomID,
                status: "opened",
              });
            }
            if (data.Type === "RoomClosed") {
              EventBus.$emit("update-local-room-status", {
                roomID: data.RoomID,
                status: "closed",
              });
            }
            if (data.Type === "RoomAbandoned") {
              EventBus.$emit("update-local-room-status", {
                roomID: data.RoomID,
                status: "abandon",
              });
            }
          });
        }
      },
    },
  },
  methods: {
    pushNotification(title, message) {
      console.log("pushNotification", title, message);
      if (this.canPushNotification && Notification.permission === "granted") {
        const notification = new Notification(title, {
          body: message,
          icon: "https://shop.villamarket.com/img/logo-villa-mobile.349b5202.svg",
        });
        notification.onclick = (e) => {
          console.log("onclick notification", e);
        };
      }
    },
    onAccept(notif) {
      console.log("onAccept", notif);
      this.removeNotification(notif.RefID);
      this.$store.dispatch("chat/acceptToJoin", notif);
    },
    onReject(notif) {
      console.log("onReject", notif);
      this.removeNotification(notif.RefID);
      this.$store.dispatch("chat/rejectToJoin", notif);
    },
    onViewRoomDetail(notif) {
      console.log("onViewRoomDetail", notif);
      this.$store.commit("chat/setSelectedRoomID", notif.RoomID);
      if (notif.Type !== "agent-join-request-notification") {
        this.removeNotification(notif.RefID);
      }
    },
    removeNotification(id) {
      this.notifications.splice(
        this.notifications.findIndex((ntf) => ntf.id === id),
        1
      );
    },
  },
  beforeDestroy() {
    this.consoleSocket.close();
  },
};
</script>

<style></style>
